import Auth from "@/util/auth.js";
import configure from './configure';
/**
 * 基本表单功能
 * 如果表单涉及审批流程，请使用process.js
 */
export default {
    extends: configure,
    props: {
        // 传入单据ID
        initId: Number,
        // 或者直接传入单据数据
        initData: Object,
        // 从哪里打开的
        opener: String
    },
    data() {
        return {
            baseUrl: null,
            statusField: null,
            idField: 'id',
            form: {
                main: {},
                items: []
            },
            appId: 'trade-app'
        };
    },
    watch: {
        initData(newVal, oldVal) {
            if (oldVal && newVal) {
                this.form = newVal
            }
        }
    },
    created() {
        var me = this;
        if (me.initData) {
            // 分享页面通过init-data属性传递
            me.form = me.initData;
        } else if (me.initId) {
            // 审批页面通过init-id属性传递
            me.f_get();
        }
        // 有些页面需要区分版本
        Auth.get().then(function (data) {
            me.appId = data.appId;
        })
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.params.id || to.query.id) {
                vm.f_get();
            } else if (to.params.initData) {
                // 通过路由传initData的情况
                vm.form = to.params.initData;
            } else if (!vm.initId && !vm.initData) {
                if (vm.originalForm) {
                    vm.form = vm.$clone(vm.originalForm);
                }
            }
            // 因为router切换时页面有缓存，备份一下初始化form参数
            if (!vm.originalForm) {
                vm.originalForm = vm.$clone(vm.form);
            }
        });
    },
    computed: {
        readonly() {
            var me = this;
            // initId是流程单据用到，initData是分享单据用到
            // 两种情况下都不允许任何操作
            return me.initId || me.initData;
        },
        /**
         * 是否可编辑
         */
        editable() {
            var me = this, main = me.form.main, s;
            if (me.readonly) {
                return false;
            }
            if (me.statusField) {
                s = main[me.statusField];
                // 已提交状态下，点击编辑后保存时，会执行反提交->保存->提交
                // 未提交状态下，点击编辑后保存时，会执行保存->提交
                return ['UNAUDITED', 'SUBMITTED', '未审核', '已提交'].indexOf(s) != -1;
            }
            return false;
        },
        /**
         * 是否制造版
         * @returns 
         */
        isMakeApp() {
            return this.appId == 'make-app';
        }
    },
    methods: {
        /**
         * 读取数据
         */
        f_get(callback, id) {
            var me = this;
            id = id || me.initId || me.$route.params.id || me.$route.query.id;
            if (id) {
                me.$loading({
                    url: me.baseUrl + "/read/" + id,
                    params: me.caller ? { caller: me.caller } : null
                }).then(function (res) {
                    if (res.success) {
                        me.form = res.data;
                        if (callback && typeof callback === 'function') {
                            callback.call(me, res.data);
                        }
                        if (me.f_afterload && typeof me.f_afterload === 'function') {
                            me.f_afterload.call(me, res.data);
                        }
                    } else {
                        me.$router.push({
                            name: "Error",
                            params: res
                        });
                    }
                });
            } else if (me.initData) {
                me.form = me.initData;
            }
        },
        /**
        * 保存/更新数据
        * @param {*} callback 
        */
        f_save(callback) {
            var me = this, main = me.form.main;
            if (me.statusField && main[me.statusField] && ['SUBMITTED', '已提交'].indexOf(main[me.statusField]) != -1) {
                main[me.statusField] = (main[me.statusField] === 'SUBMITTED') ? 'UNAUDITED' : 'SUBMITTED';
            }

            me.$loading({
                method: "post",
                url: me.saveUrl || (me.baseUrl + "/save" + (me.caller ? "?caller=" + me.caller : "")),
                jsonData: me.form
            }).then(function (res) {
                if (res.success) {
        
                    if (res.data && res.data[me.idField]) {
                        me.form.main[me.idField] = res.data[me.idField];
                        Object.assign(me.form.main, res.data);
                        me.f_reload();
                    }
                    if (callback && typeof callback === 'function') {
                        callback.call(me, res);
                    } else {
                        var isUpdate = me.initId || me.$route.params.id || me.$route.query.id || me.$route.params.initData;
                        if (isUpdate) {
                            me.$router.back();
                        } else {
                            var editName = me.$route.name,
                                readName = editName.substr(0, editName.length - 4);
                            if (res.data) {
                                setTimeout(function () {
                                    me.$router.push({
                                        name: readName,
                                        params: {
                                            id: res.data.id
                                        }
                                    });
                                }, 100);
                            } else {
                                me.$router.go(-2);
                            }
                        }
                    }
                } else {
                    me.$weui.topTips("保存失败：" + res.message, 3000);
                }
            });
        },
        /**
             * 通过 id 重新从后端读取单据数据（走 /read 接口）。
             * 典型场景：f_save 成功但后续 pre_launch/launch 失败，
             * 此时单据已落库但前端 form 还停留在新增状态，调用本方法刷新，
             * 确保后续再次提交走更新，不会重复新建单据。
             * @param {Function} callback 刷新成功后的回调，可选
             */
        f_reload(callback) {
            var me = this,
                id = me.form.main && me.form.main[me.idField];
            if (!id) {
                if (callback && typeof callback === 'function') {
                    callback.call(me);
                }
                return;
            }
            me.$loading({
                url: me.baseUrl + "/read/" + id,
                params: me.caller ? { caller: me.caller } : null
            }).then(function (res) {
                if (res.success) {
                    me.form = res.data;
                    if (me.f_afterload && typeof me.f_afterload === 'function') {
                        me.f_afterload.call(me, res.data);
                    }
                }
                if (callback && typeof callback === 'function') {
                    callback.call(me, res);
                }
            });
        },
        /**
         * 更新数据，针对部分业务区分了save、update的场景
         * @param {*} callback 
         */
        f_update(callback) {
            var me = this;
            me.$loading({
                method: "post",
                url: me.baseUrl + "/update" + (me.caller ? "?caller=" + me.caller : ""),
                jsonData: me.form
            }).then(function (res) {
                if (res.success) {
                    if (callback && typeof callback === 'function') {
                        callback.call(me, res);
                    } else {
                        // 默认跳转回
                        me.$router.back();
                    }
                } else {
                    me.$weui.topTips("更新失败：" + res.message, 3000);
                }
            });
        },
        /**
         * 审核
         * @param {*} callback 
         */
        f_audit(callback) {
            var me = this;
            me.$weui.confirm('确定审核单据？', function () {
                me.$loading({
                    url: me.baseUrl + "/audit" + (me.caller ? "?caller=" + me.caller : ""),
                    method: 'POST',
                    jsonData: me.form
                }).then(function (res) {
                    if (res.success) {
                        me.$weui.toast("审核成功", 2000);
                        if (callback && typeof callback === 'function') {
                            callback.call(me, res);
                        } else {
                            setTimeout(function () {
                                window.location.reload();
                            }, 100);
                        }
                    } else {
                        me.$router.push({
                            name: "Error",
                            params: res
                        });
                    }
                });
            });
        },
        /**
         * 反审核
         * @param {*} callback 
         * @param {*} id 
         */
        f_unaudit(callback, id) {
            var me = this, main = me.form.main;
            id = id || main[me.idField];
            me.$weui.confirm('确定反审核单据？', function () {
                me.$loading({
                    url: me.baseUrl + "/unAudit/" + id + (me.caller ? "?caller=" + me.caller : ""),
                    method: 'POST'
                }).then(function (res) {
                    if (res.success) {
                        me.$weui.toast("反审核成功", 2000);
                        if (callback && typeof callback === 'function') {
                            callback.call(me, res);
                        } else {
                            setTimeout(function () {
                                window.location.reload();
                            }, 100);
                        }
                    } else {
                        me.$router.push({
                            name: "Error",
                            params: res
                        });
                    }
                });
            });
        },
        /**
         * 删除数据，含提示
         * @param {*} callback 
         * @param {*} id 
         */
        f_remove(callback, id) {
            var me = this;
            me.$weui.confirm('确定删除单据？', function () {
                me.f_delete(callback, id);
            });
        },
        /**
         * 删除数据
         * @param {*} callback 
         * @param {*} id 
         */
        f_delete(callback, id) {
            var me = this, main = me.form.main;
            id = id || main[me.idField];
            me.$loading({
                url: me.baseUrl + '/delete/' + id + (me.caller ? "?caller=" + me.caller : ""),
                method: 'POST'
            }).then(function (res) {
                if (res.success) {
                    me.$weui.toast("删除成功", 2000);
                    if (callback && typeof callback === 'function') {
                        callback.call(me);
                    } else {
                        // 默认跳转回列表页
                        me.$router.push({
                            name: me.$route.name + 'List'
                        });
                    }
                } else {
                    me.$weui.topTips("删除失败: " + res.message, 3000);
                }
            }).catch(function () {
                me.$weui.topTips("删除失败", 3000);
            });
        },

        /**
         * 删除明细行
         * 若 id 有值则调用后端接口删除，成功后执行 callback（通常在 callback 中 splice 数组）
         * 若 id 无值则直接执行 callback
         * @param {*} id 明细行主键（为空时不调接口）
         * @param {*} callback 成功后的回调（必传，用于 items.splice）
         */
        f_deleteDetail(id, callback) {
            var me = this;
            if (!id) {
                if (callback && typeof callback === 'function') {
                    callback.call(me);
                }
                return;
            }
            me.$loading({
                url: me.baseUrl + '/deleteDetail/' + id + (me.caller ? "?caller=" + me.caller : ""),
                method: 'POST'
            }).then(function (res) {
                if (res.success) {
                    me.$weui.toast('删除成功', 1000);
                    if (callback && typeof callback === 'function') {
                        callback.call(me, res);
                    }
                } else {
                    me.$weui.topTips("删除失败：" + res.message, 3000);
                }
            }).catch(function () {
                me.$weui.topTips("删除失败", 3000);
            });
        },
        /**
         * 启用/禁用
         * @param {*} enabled 
         * @param {*} id 
         * @param {*} callback 
         */
        f_enable(enabled, id, callback) {
            var me = this, main = me.form.main;
            id = id || main[me.idField];
            me.$loading({
                url: me.baseUrl + "/" + (enabled ? "open" : "close") + "/" + id + (me.caller ? "?caller=" + me.caller : ""),
                method: "POST"
            })
                .then(function (res) {
                    if (res.success) {
                        me.$weui.toast((enabled ? "启用" : "禁用") + "成功", 2000);
                        if (callback && typeof callback === "function") {
                            callback.call(me);
                        } else {
                            setTimeout(function () {
                                window.location.reload();
                            }, 100);
                        }
                    } else {
                        me.$weui.topTips("操作失败: " + res.message, 3000);
                    }
                })
                .catch(function () {
                    me.$weui.topTips("操作失败", 3000);
                });
        }
    }
};